import { IUpdateAcaoPrevCorretivasUseCase } from "../../../presentation/useCases/update/updade_acao_prev_corretivas_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// UpdateAcaoPrevCorretivasUseCase


export class UpdateAcaoPrevCorretivasUseCase implements IUpdateAcaoPrevCorretivasUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async updateAcaoPrevCorretivas(IdAcaoPrevCorretiva: number,
 IdAcaoQualidade: number, Tipo: 'C' | 'P' | null, Numero: number | null,  Descricao: string | null, IdFuncionarioResponsavel: number | null,  DataPrevista: Date | null, DataRealizado: Date | null, AnaliseEvidencia: string | null, DataAnalise: Date | null, FoiEficaz: boolean | null, IdFuncionarioAnalise: number | null
  ): Promise<void> {
    
    await this.repository.updateAcaoPrevCorretivas(
      IdAcaoPrevCorretiva, IdAcaoQualidade, Tipo, Numero, Descricao, IdFuncionarioResponsavel, DataPrevista, DataRealizado, AnaliseEvidencia, DataAnalise, FoiEficaz, IdFuncionarioAnalise
    );
  }
}
